<template>
  <div>
    <!--Modal AddEditMesaVotacion-->
    <div v-if="edit.mostrarModal">
      <add-edit-mesa-votacion v-model="edit.mostrarModal" :mesa-votacion-id="edit.mesaVotacionId" @onSave="handleAddEditMesaVotacionSaved"></add-edit-mesa-votacion>
    </div>
    <!--Modal Nivel Acceso Mesa-->
    <div v-if="editNivelAcceso.mostrarModal">
      <edit-nivel-acceso-mesa v-model="editNivelAcceso.mostrarModal" :mesa-votacion-id="editNivelAcceso.mesaVotacionId" @onSave="handleNivelAccesoSaved"></edit-nivel-acceso-mesa>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-form>
          <div class="card card-custom">
            <div class="card-header flex-wrap border-0 pt-6 pb-0">
              <div class="card-title">
                <h3 class="card-label"><i class="fas fa-filter"></i> Filtros</h3>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3">
                  <label class="font-weight-bold">Nro. de mesa</label>
                  <b-form-input id="input-1" v-model="filter.nroMesa" required placeholder="Nro. de mesa"></b-form-input>
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">Local de votación</label>
                  <b-form-input id="input-2" v-model="filter.descripcion" required placeholder="Nombre o dirección"></b-form-input>
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">Región</label>
                  <select class="form-control" v-model="filter.regionId">
                    <option :value="null">- Seleccionar -</option>
                    <option v-for="region in regiones" :value="region.regionId" :key="region.regionId">{{ region.nombre }}</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold"> Sub región</label>
                  <select class="form-control" v-model="filter.subRegionId">
                    <option :value="null">- Seleccionar -</option>
                    <option v-for="subRegion in subRegiones" :value="subRegion.subRegionId" :key="subRegion.subRegionId">{{ subRegion.nombre }}</option>
                  </select>
                </div>
              </div>
              <!--  <div class="row mt-3">
                <div class="col-md-3">
                  <label class="font-weight-bold">Estado turno 1</label>
                  <select class="form-control" v-model="filter.estadoTurno1">
                    <option :value="null">Todos</option>
                    <option :value="1">Pendiente</option>
                    <option :value="2">En proceso</option>
                    <option :value="3">Finalizado</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">Estado turno 2</label>
                  <select class="form-control" v-model="filter.estadoTurno2">
                    <option :value="null">Todos</option>
                    <option :value="1">Pendiente</option>
                    <option :value="2">En proceso</option>
                    <option :value="3">Finalizado</option>
                  </select>
                </div>
               <div class="col-md-3">
                  <label class="font-weight-bold">Estado turno 3</label>
                  <select class="form-control" v-model="filter.estadoTurno3">
                    <option :value="null">Todos</option>
                    <option :value="1">Pendiente</option>
                    <option :value="2">En proceso</option>
                    <option :value="3">Finalizado</option>
                  </select>
                </div> 
              </div>-->
            </div>
            <div class="card-footer padding-t-b">
              <div class="col-md-12">
                <!-- <a href="#" class="btn btn-success font-weight-bold mr-2 alignment-right" @click.prevent="downloadReporteExcel()"><i class="fa fa-file-excel"></i> Reporte</a> -->
                <a href="#" class="btn btn-primary font-weight-bold mr-2 alignment-right" @click.prevent="searchMesasVotacion()"><i class="fa fa-search"></i> Buscar</a>
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <div class="card card-custom">
          <div class="card-header flex-wrap border-0 pt-6 pb-0">
            <div class="card-title">
              <h3 class="card-label"><i class="la la-building"></i> Mesas de Votación</h3>
            </div>
            <div class="card-toolbar">
              <a href="#" class="btn btn-primary font-weight-bold mr-2" @click.prevent="doAddEditMesaVotacion()"><i class="la la-plus"></i> Nuevo</a>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-head-custom table-vertical-center table-head-bg table-hover" style="min-height: 150px;">
                <thead>
                  <tr>
                    <th>Mesa</th>
                    <th>Código</th>
                    <th>
                      Local / Dirección
                    </th>
                    <th>
                      Sub Región / Región
                    </th>
                    <th>Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="mesa in mesas" :key="mesa.localVotacionMesaId">
                    <td>
                      {{ mesa.nroMesa }}
                    </td>
                    <td>
                      {{ mesa.codigo }}
                    </td>
                    <td>
                      {{ mesa.localVotacion }}<br />
                      <small class="text-muted">{{ mesa.direccion }}</small>
                    </td>
                    <td>
                      {{ mesa.subRegionNombre }}<br />
                      <small class="text-muted">{{ mesa.regionNombre }}</small>
                    </td>
                    <td>
                      <b-dropdown right>
                        <template #button-content>
                          <i class="fas fa-ellipsis-v"></i>
                        </template>
                        <b-dropdown-item href="#" @click.prevent="doAddEditMesaVotacion(mesa.localVotacionMesaId)"><span class="navi-icon"><i class="la la-pen text-dark"></i> Editar</span></b-dropdown-item>
                        <b-dropdown-item href="#" @click.prevent="doAddEditNivelAcceso(mesa.localVotacionMesaId)"><span class="navi-icon"><i class="la la-level-down-alt text-dark"></i> Nivel Acceso</span></b-dropdown-item>
                        <b-dropdown-item href="#" @click.prevent="doFichaSeguimientoElectoral(mesa.localVotacionId, mesa.localVotacionMesaId)"><span class="navi-icon"><i class="la la-clipboard-list text-dark"></i> Ficha</span></b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-footer d-flex flex-wrap align-items-center justify-content-between" v-if="pagination.totalCount > 0">
            <small class="text-muted mr-3">{{ pagination.totalCount }} registro(s)</small>
            <b-pagination v-model="pagination.page" :total-rows="pagination.totalCount" :per-page="pagination.pageSize" hide-goto-end-buttons class="m-0" size="md" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cell-width-10 {
  width: 10%;
}

.cell-width-60 {
  width: 60%;
}

.cell-width-20 {
  width: 20%;
}

.alignment-right {
  float: right;
}

.padding-t-b {
  padding-top: 15px;
  padding-bottom: 15px;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Table from "../pages/vue-bootstrap/Table.vue";
import addEditMesaVotacion from "@/components/location/add-edit-mesa-votacion";
import editNivelAccesoMesa from "@/components/location/edit-nivel-acceso-mesa";
import Swal from "sweetalert2";

/*intervalos de tiempo de Inactividad*/
import { INACTIVE_USER_TIME_THRESHOLD, USER_ACTIVITY_THROTTLER_TIME } from "@/helpers/constants.js";

export default {
  name: "list-mesa-votacion",
  components: {
    addEditMesaVotacion,
    editNivelAccesoMesa,
  },
  props: {},
  data: () => ({
    mesas: [],
    edit: {
      mostrarModal: false,
      mesaVotacionId: null,
    },
    editNivelAcceso: {
      mostrarModal: false,
      mesaVotacionId: null,
    },
    pagination: {
      page: 1,
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,
    },
    filter: {
      regionId: null,
      subRegionId: null,
      codigo: "",
      descripcion: "",
      nroMesa: "",
      estadoTurno1: null,
      estadoTurno2: null,
      estadoTurno3: null,
    },
    regiones: [],
    subRegiones: [],
    /*variables de inactividad*/
    isInactive: false,
    userActivityThrottlerTimeout: null,
    userActivityTimeout: null,
    localesVotacion: [],
  }),
  computed: {},
  methods: {
    getProcesoElectoralIdFilter: function () {
      var id = this.$session.get("ProcesoElectoralId");
      if (id == null || id === "") return null;
      var n = parseInt(id, 10);
      return isNaN(n) || n <= 0 ? null : n;
    },
    doAddEditMesaVotacion: function (mesaVotacionId) {
      this.edit.mesaVotacionId = mesaVotacionId;
      this.edit.mostrarModal = true;
    },
    doAddEditNivelAcceso: function (mesaVotacionId) {
      this.editNivelAcceso.mesaVotacionId = mesaVotacionId;
      this.editNivelAcceso.mostrarModal = true;
    },
    doFichaSeguimientoElectoral: function (localVotacionId, mesaVotacionId) {
      this.$router.push({
        name: "sheet-mesa-edit-2026",
        params: {
          procesoElectoralId: this.$session.get("ProcesoElectoralId"),
          mesaVotacionId: mesaVotacionId,
          localVotacionId: localVotacionId,
        },
      });
    },
    handleAddEditMesaVotacionSaved: function (obj) {
      this.fetchMesasVotacion();
    },
    handleNivelAccesoSaved: function (obj) {
      //alert(JSON.stringify(obj));
      // this.fetchLocalesVotacion();
    },
    searchMesasVotacion: function () {
      if (this.pagination.page !== 1) {
        this.pagination.page = 1;
      } else {
        this.fetchMesasVotacion();
      }
    },
    downloadReporteExcel: async function () {
      try {
        var payload = {
          regionId: this.filter.regionId,
          subRegionId: this.filter.subRegionId,
          codigo: this.filter.codigo,
          descripcion: this.filter.descripcion,
          nroMesa: this.filter.nroMesa,
          procesoElectoralId: this.getProcesoElectoralIdFilter(),
          estadoTurno1: this.filter.estadoTurno1,
          estadoTurno2: this.filter.estadoTurno2,
          estadoTurno3: this.filter.estadoTurno3,
        };

        var url = this.apiRoute("Location", "ExportReporteMesaLocalExcel");
        var token = this.$session.get("jwt");

        var res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? "Bearer " + token : "",
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) throw new Error("No se pudo generar el reporte.");

        var blob = await res.blob();
        var fileName = "Reporte_Mesa_Local.xlsx";
        var disposition = res.headers.get("content-disposition");
        if (disposition && disposition.toLowerCase().includes("filename=")) {
          var match = disposition.match(/filename="?([^"]+)"?/i);
          if (match && match[1]) fileName = match[1];
        }

        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      } catch (e) {
        Swal.fire({ icon: "error", title: "Error", text: e.message || "No se pudo descargar el reporte." });
      }
    },
    fetchMesasVotacion: function () {
      var p = this.pagination || {};
      var model = {
        pagination: {
          paginate: true,
          page: p.page != null ? p.page : 1,
          size: p.pageSize != null ? p.pageSize : 10,
        },
        regionId: this.filter.regionId,
        subRegionId: this.filter.subRegionId,
        codigo: this.filter.codigo,
        descripcion: this.filter.descripcion,
        nroMesa: this.filter.nroMesa,
        procesoElectoralId: this.getProcesoElectoralIdFilter(),
        estadoTurno1: this.filter.estadoTurno1,
        estadoTurno2: this.filter.estadoTurno2,
        estadoTurno3: this.filter.estadoTurno3,
      };

      this.$http.post(this.apiRoute("Location", "ListMesasVotacion"), model).then(function (response) {
        if (response.body.error) {
          this.mesas = [];
          return;
        }
        this.mesas = response.body.data.items;
        var pag = response.body.data.pagination || {};
        this.pagination = {
          page: pag.page != null ? pag.page : 1,
          pageSize: pag.pageSize != null ? pag.pageSize : this.pagination.pageSize || 10,
          totalCount: pag.totalCount != null ? pag.totalCount : 0,
          totalPages: pag.totalPages != null ? pag.totalPages : 0,
          hasPreviousPage: pag.hasPreviousPage,
          hasNextPage: pag.hasNextPage,
        };
      });
    },
    fetchRegiones: function () {
      var modelRegion = {};
      this.$http.post(this.apiRoute("Region", "ListRegiones"), modelRegion).then(function (response) {
        this.regiones = response.body.data.items;
      });
    },
    fetchSubRegiones: function (regionId) {
      this.$http
        .get(this.apiRoute("Region", "ListSubRegionesPorRegion"), {
          params: {
            RegionId: regionId,
          },
        })
        .then(function (response) {
          this.subRegiones = response.body.data.items;
        });
    },
    /*Metodos para verificar la inactividad del usuario*/
    activateActivityTracker: function () {
      window.addEventListener("mousedown", this.userActivityThrottler);
      window.addEventListener("mousemove", this.userActivityThrottler);
      window.addEventListener("scroll", this.userActivityThrottler);
      window.addEventListener("keydown", this.userActivityThrottler);
      window.addEventListener("resize", this.userActivityThrottler);
      window.addEventListener("touchstart", this.userActivityThrottler); //para dispositivos moviles
    },
    deactivateActivityTracker: function () {
      window.removeEventListener("mousedown", this.userActivityThrottler);
      window.removeEventListener("mousemove", this.userActivityThrottler);
      window.removeEventListener("scroll", this.userActivityThrottler);
      window.removeEventListener("keydown", this.userActivityThrottler);
      window.removeEventListener("resize", this.userActivityThrottler);
      window.removeEventListener("touchstart", this.userActivityThrottler); //para dispositivos moviles
    },
    resetUserActivityTimeout: function () {
      clearTimeout(this.userActivityTimeout);

      this.userActivityTimeout = setTimeout(() => {
        this.userActivityThrottler();
        this.inactiveUserAction();
      }, INACTIVE_USER_TIME_THRESHOLD); /*=> INACTIVE_USER_TIME_THRESHOLD */
    },
    userActivityThrottler: function () {
      if (this.isInactive) {
        this.isInactive = false;
      }

      if (!this.userActivityThrottlerTimeout) {
        this.userActivityThrottlerTimeout = setTimeout(() => {
          this.resetUserActivityTimeout();
          clearTimeout(this.userActivityThrottlerTimeout);
          this.userActivityThrottlerTimeout = null;
        }, USER_ACTIVITY_THROTTLER_TIME); /*=> USER_ACTIVITY_THROTTLER_TIME*/
      }
    },
    inactiveUserAction: function () {
      this.isInactive = true;

      Swal.fire({
        icon: "warning",
        title: "Sesión Expirada",
        text: "Su sesión ha expirado. Por favor vuelva a iniciar sesión.",
        confirmButtonText: `Iniciar Sesión`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.deactivateActivityTracker();
          clearTimeout(this.userActivityTimeout);
          clearTimeout(this.userActivityThrottlerTimeout);
          this.$router.push({ name: "login" });
        }
      });
    },
  },
  watch: {
    "filter.regionId": function (newValue, oldValue) {
      this.fetchSubRegiones(newValue);
    },
    "pagination.page": function (newVal, oldVal) {
      if (newVal === oldVal) return;
      this.fetchMesasVotacion();
    },
  },
  mounted: function () {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Mesas de Votacion" }]);
    this.fetchRegiones();
    this.fetchMesasVotacion();
    this.activateActivityTracker();
  },
  destoyed: function () { },
};
</script>
